import { render, staticRenderFns } from "./DashboardCommandesEnCoursCard.vue?vue&type=template&id=3a516e4e&"
import script from "./DashboardCommandesEnCoursCard.vue?vue&type=script&lang=ts&"
export * from "./DashboardCommandesEnCoursCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports